import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

import { FormattedMessage } from '../../util/reactIntl';
import NamedLink from '../NamedLink/NamedLink';

import css from './CookieConsent.module.css';

// Nextmine: GDPR cookie-samtykke-banner.
//
// Nødvendige cookies (login/session, samtykke selv) er altid slået til. Ikke-
// nødvendige (analyse/marketing - endnu ikke tilkoblet, men fremtidssikret)
// kræver aktivt samtykke. Valget gemmes i cookien `nextmineCookieConsent`
// ('all' eller 'essential') i 180 dage, så banneret ikke dukker op igen.
//
// Klient-only: renderes først EFTER mount (undgår SSR/hydrerings-mismatch, da
// serveren ikke kender brugerens samtykke-cookie ved render-tid). En anden del
// af koden kan senere læse Cookies.get('nextmineCookieConsent') === 'all' før
// den loader analyse-scripts.
const CONSENT_COOKIE = 'nextmineCookieConsent';
const CONSENT_DAYS = 180;

const CookieConsent = () => {
  const [mounted, setMounted] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const alreadyChosen = mounted ? !!Cookies.get(CONSENT_COOKIE) : true;

  if (!mounted || alreadyChosen || dismissed) {
    return null;
  }

  const choose = value => {
    Cookies.set(CONSENT_COOKIE, value, { expires: CONSENT_DAYS, sameSite: 'lax' });
    setDismissed(true);
  };

  return (
    <div className={css.root} role="dialog" aria-live="polite" aria-label="Cookie consent">
      <div className={css.inner}>
        <p className={css.text}>
          <FormattedMessage
            id="CookieConsent.text"
            values={{
              privacyLink: (
                <NamedLink name="PrivacyPolicyPage" className={css.link}>
                  <FormattedMessage id="CookieConsent.privacyLink" />
                </NamedLink>
              ),
            }}
          />
        </p>
        <div className={css.actions}>
          <button type="button" className={css.essentialButton} onClick={() => choose('essential')}>
            <FormattedMessage id="CookieConsent.essentialButton" />
          </button>
          <button type="button" className={css.acceptButton} onClick={() => choose('all')}>
            <FormattedMessage id="CookieConsent.acceptButton" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
